<template>
  <div id="serveMy">
    <div class="top">
        <div class="mobileTop"></div>
        <div class="topPart">
          <span class="backToApp" @click="back()"></span>商品需求<i class="share"></i>
        </div>
    </div>
    <div class="main">
      <p class="lineTit">填写商品需求信息</p>
      <van-form ref="sub">

        <van-field class="importent" placeholder="输入姓名" label="姓名：" v-model="sub.name" :rules="name">
        </van-field>
        <van-field class="importent"  placeholder="输入手机号" label="手机号：" v-model="sub.phone" :rules="phone">
        </van-field>
        <van-field class="select"  label="所在地：" placeholder="选择所在地" v-model="areaL" @click="showCity = !showCity">
        </van-field>
        <van-field  label="服务内容：" v-model="sub.service_content_details" :value="value"
            placeholder="请输入留言内容"
            rows="1"
            type="textarea"
            show-word-limit
            maxlength="500">
        </van-field>
      </van-form>
      <van-popup v-model="showCity" position="bottom" :style="{paddingBottom: '30px'}">
            <van-area :area-list="area" :columns-num="3" @confirm="confArea"  @change="onChange"  @cancel="onCancel"></van-area>
        </van-popup>
      <van-button type="primary" :disabled="!canSub" @click.native="onSubmit">确定提交</van-button>

    </div>
    <el-dialog :visible.sync="subSuccess" style="margin-top: calc(50% - 90px);">
        <div class="top">
          <div class="succ"></div>
          <p class="tit">需求提交成功</p>
          <p class="des">已收到您的需求</p>
          <p class="des">我们将在1个工作日内给您回复</p>
        </div>
        <div v-show="!zero" class="close">{{ '知道了('+cont+'s)' }}</div>
        <div v-show="zero" class="close" @click="closeD()">{{ '关闭' }}</div>
      </el-dialog>
      <server></server>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data'
import server from './component/server.vue'
export default {
  components: {
    server
  },
  watch: {
    sub: {
      handler (newVal, oldVal) {
        if (this.isFormEmpty()) {
          console.log('存在空值')
          this.canSub = false
        } else {
          console.log('全部填写')
          this.canSub = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      cont: 5,
      zero: false,
      subSuccess: false,
      canSub: false,
      showCity: false,
      area: areaList,
      sub: {
        name: '',
        phone: '',
        province: '',
        city: '',
        area: '',
        service_content: '',
        service_content_details: ''
      },
      areaL: [],
      value: '',
      name: [
        {
          required: true,
          message: '请输入姓名',
          triggle: 'blur'
        }
      ],
      phone: [
        {
          triggle: 'blur',
          message: '请输入手机号',
          type: 'number',
          required: true
        }, {
          validator: value => {
            return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
              .test(value)
          },
          message: '请输入正确格式的手机号码',
          trigger: 'onBlur'
        }
      ]

    }
  },
  mounted () {
    console.log(this.area)
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    closeD () {
      this.subSuccess = false
    },
    isFormEmpty () {
      console.log(this.sub)
      return Object.values(this.sub).includes('')
    },
    onSubmit () {
      console.log(this.canSub)
      if (this.canSub) {
        this.utils.post(this.accountUrl + '/serviceRequire/save', this.sub, (res) => {
          this.zero = false
          this.subSuccess = true
          setInterval(() => {
            this.cont--
            if (this.cont == 0) {
              this.zero = true
            }
          }, 1000)
        })
      }
    },
    /**
     * 数据滚动选择监听数据变化
     * @param picker
     * @param index
     * @param value
     * value=0改变省，1改变市，2改变区
     */
    onChange (picker, index, value) {
      let val = picker.getValues()
      console.log(val)// 查看打印
      let areaName = ''
      for (var i = 0; i < val.length; i++) {
        areaName = areaName + (i == 0 ? '' : '/') + val[i].name
      }
      // 保存滚动选择的值
      this.chooseTempValue = areaName
      console.log('chooseTempValue', this.chooseTempValue)
    },
    // 当提交表单数据时需要，将地区数据提交到后端，因此，当选择完成后
    // 确定选择后保存事件
    confArea (data) {
      data.forEach(() => {
        this.sub.province = data[0] ? data[0].name : ''
        this.sub.city = data[1] ? data[1].name : ''
        this.sub.area = data[2] ? data[2].name : ''
      })
      this.areaL = this.sub.province + ' ' + this.sub.city + ' ' + this.sub.area
      this.showCity = !this.showCity
      console.log(this.sub)
    },
    onCancel () {
      this.showCity = false// 关闭弹框
      // 由于对滚动的数据保存到临时的变量chooseTempValue中，与选择后现实的数据做了解耦合，因此，这里不炫耀重置城市列表
      // this.$refs.myArea.reset()// 重置城市列表
    },
    handleChange () {}
  }
}
</script>

<style lang='scss' scoped>
#serveMy{
  background: rgb(249, 249, 249);
  display: inline-block;
  width: 100vw;
  height: calc(100vh + 110px);
  .top{
    background: #ffffff;
    width: 100%;
    .mobileTop{
      height: 27px;
    }
    .topPart{
      display: inline-block;
      width: 100%;
      height: 40px;
      line-height: 40px;
      position: relative;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #1D2129;
      text-align: center;
      .backToApp{
        display: inline-block;
        position: absolute;
        left: 15px;
        top: 5px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        &::before{
          content: '';
          position: absolute;
          left: 0;
          top: calc(50% - 6px);
          right: 0;
          margin: 0 auto;
          width: 12px;
          height: 12px;
          border-top: 2px solid #1D2129;
          border-left: 2px solid #1D2129;
          transform: rotate(-45deg);
        }
      }
      .share{
          position: absolute;
          right:20px;
          width: 16px;
          height: 16px;
          top: 12px;
          background: url('./images/share.svg')no-repeat center center;
          background-size: cover;
      }
    }
  }
  .main{
    display: inline-block;
    width: 100%;
    background: #FFFFFF;
    .lineTit{
      display: inline-block;
      width: 100%;
      line-height: 49px;
      padding-left: 30px;
      font-size: 14px;
      color: #525864;
      font-weight: bold;
      border-bottom: 0.026667rem solid #ebedf0;
    }
    >>> .van-form{
      .van-cell{
        padding: 0 30px;
        line-height: 49px;
        &.importent{
          position: relative;
          &::before{
            content:'*';
            position: absolute;
            font-size: 14px;
            color: #c41335;
            left: 17px;
          }
        }

        &::after{
          width: 100%;
          left: 0;
        }
        &:last-child{
          display: inline-block;
          .van-cell__title{
            width: 100%;
          }
          .van-cell__value{
            position: relative;
            display: inline-block;
            width: 100%;
            .van-field__body{
              display: inline-block;
              width: 100%;
              textarea{
                padding: 15px;
                border-radius: 5px;
                border: 0.026667rem solid #ebedf0;
                height: 200px;
              }
            }
            .van-field__word-limit{
              position: absolute;
              right: 15px;
              bottom: 30px;
            }
          }
          &::after{
            content:none
          }
        }
        &.select{
          position: relative;
          &::before{
            content:'';
            position: absolute;
            width: 10px;
            height: 10px;
            right: 30px;
            top: 20px;
            left: auto;
            border-top: 1px solid #91919C;
            border-right: 1px solid #91919C;
            border-bottom: none;
            transform: rotate(45deg);
          }
        }
      }
    }
    >>> .van-button--normal{
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      height: 104px;
      line-height: 70px;
      background: #ffffff;
      border-color: #ffffff;
      z-index: 100;
      .van-button__content{
        display: inline-block;
        background: #9E918B;
        width: calc(100% - 30px);
        height: 45px;
        .van-button__text{
          display: inline-block;
          height: 45px;
          line-height: 45px;
          vertical-align: top;
        }
      }
      &.van-button--disabled{
        opacity: 1;
        .van-button__content{
          background: #E4E0DF;
        }
      }
    }
  }
  /deep/ .el-dialog {
    position: relative;
    border-radius: 4px;
    width: 280px;
    height: 206px;
    border-radius: 4px 4px 4px 4px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      height: 100%;
    font-size: 0;
    border-radius: 4px 4px 4px 4px;
      .top{
        text-align: center;
        padding-top: 30px;
        padding-bottom: 18px;
        border-radius: 4px 4px 4px 4px;
        .succ{
          display: inline-block;
          border-radius: 50%;
          width: 31px;
          height: 31px;
          background: url('./images/gg.png')no-repeat center center, linear-gradient(176deg, #7D7D7D, #262626);
          background-size: 55%;
          margin-bottom: 15px;
        }
        .tit{
          font-size: 16px;
          color: #1d2129;
          line-height: 16px;
          margin-bottom: 15px;
        }
        .des{
          font-size: 12px;
          color: #525864;
        }
      }
      .close{
        display: inline-block;
        width: 100%;
        height: 50px;
        background: #9E918B;
        border-radius: 0px 0px 4px 4px;
        text-align: center;
        font-size: 16px;
        color: #ffffff;
        line-height: 50px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/manman/serveMy.vue